import { Product } from '#/products/types';
import { Strategy } from '#/shared/strategies';
import { Maybe } from '@paradigm/utils/types';

export function supportsStrategy(product: Product, strategy: Strategy) {
  return (
    strategy.kind === product.kind &&
    (product.strategies === 'all' || product.strategies.includes(strategy.code))
  );
}
export function supportsStrategyShortcuts(
  product: Maybe<Product>,
  strategy: Strategy,
) {
  // if `product` not defined we're dealing with a custom strategy.
  if (product === null) return true;
  return (
    strategy.kind === product?.kind &&
    (product.strategies === 'all' || product.strategies.includes(strategy.code))
  );
}
